import { api } from '@/api';
import { resolveStatus, sortByStatus } from '@/helpers/entityStatus';

export default {
  namespaced: true,
  state: {
    items: [],
    deletedItems: [],
    objects: [],
    tags: [],
    isLoading: false,
    current: { isLoading: false },
  },
  mutations: {
    setMoldings(state, items) { state.items = items; },
    setDeletedMoldings(state, items) { state.deletedItems = items; },
    setMoldingObjects(state, objects) { state.objects = objects; },
    setTags(state, tags) { state.tags = tags; },
    setLoading(state, isLoading) { state.isLoading = isLoading; },
    setCurrentMolding(state, data) { state.current = { ...state.current, ...data }; },
  },
  actions: {
    // Один список на все состояния: is_actual + is_archived вместе означают
    // выборку с корзиной, поэтому хватает одного запроса.
    getMoldingObjects({ commit }, params = {}) {
      commit('setLoading', true);

      return api.getMoldingsList({ is_actual: true, is_archived: true, ...params })
        .then(({ data }) => commit('setMoldingObjects', sortByStatus(
          (data ?? []).map((item) => ({ ...item, status: resolveStatus(item) })),
        )))
        .finally(() => commit('setLoading', false));
    },

    getList({ commit }, params = {}) {
      commit('setLoading', true);
      return api.getMoldingsList({ is_actual: true, is_archived: false, ...params })
        .then(({ data }) => commit('setMoldings', data))
        .finally(() => commit('setLoading', false));
    },
    getDeletedList({ commit }) {
      commit('setLoading', true);
      return api.getMoldingsList({ is_actual: false, is_archived: true })
        .then(({ data }) => commit('setDeletedMoldings', data))
        .finally(() => commit('setLoading', false));
    },
    async getMolding({ commit }, id) {
      commit('setCurrentMolding', { isLoading: true });
      const { data } = await api.getMoldingById(id);
      commit('setCurrentMolding', { ...data, isLoading: false });
      return data;
    },
    archive({ dispatch }, id) { return api.archiveMolding(id).then(() => dispatch('getMoldingObjects')); },
    restore({ dispatch }, id) { return api.restoreMolding(id).then(() => dispatch('getMoldingObjects')); },
    update({ commit }, { id, payload }) {
      return api.updateMolding(id, payload).then(({ data }) => {
        commit('setCurrentMolding', data);
        return data;
      });
    },
    async getTags({ commit }) {
      const { data } = await api.getMoldingTags();
      commit('setTags', data);
      return data;
    },
    async createTag({ dispatch }, payload) {
      await api.createMoldingTag(payload);
      return dispatch('getTags');
    },
    async updateTag({ dispatch }, { id, payload }) {
      await api.updateMoldingTag(id, payload);
      return dispatch('getTags');
    },
    async deleteTag({ dispatch }, id) {
      await api.deleteMoldingTag(id);
      return dispatch('getTags');
    },
    getStyleBindings(store, styleId) {
      return api.getStyleMoldings(styleId).then(({ data }) => data);
    },
    updateStyleBindings(store, { styleId, moldings }) {
      return api.updateStyleMoldings(styleId, moldings).then(({ data }) => data);
    },
  },
};
